import { render, staticRenderFns } from "./MinutesModal.vue?vue&type=template&id=f6bc054a&scoped=true&"
import script from "./MinutesModal.vue?vue&type=script&lang=js&"
export * from "./MinutesModal.vue?vue&type=script&lang=js&"
import style0 from "./MinutesModal.vue?vue&type=style&index=0&id=f6bc054a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bc054a",
  null
  
)

export default component.exports